module.exports = __webpack_public_path__ + "img/bg_high_way_red_square.c9b3bc2e.jpg";